import React from "react";
import "jspdf-autotable";
import ReactTable from "react-table";
import "react-table/react-table.css";
import matchSorter from "match-sorter";
import ReactExport from "react-data-export";
import { BotonExcel } from "../Plantillas/Botones";
import moment from "moment";


const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;


class StockHistoricoUI extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            auditorias: [],
            productos: [],
            sucursales: [],
            columns: [],
            isLoading: false,
            isLoadingAuditorias: false,
            isLoadingSucursales: false,
            auditoriaSeleccionada: '',
            sucursalSeleccionada: '',
            fechaInicio: this.formatMomentForInput(moment()),
            fechaFin: this.formatMomentForInput(moment())
        }

        this.formatMomentForInput = this.formatMomentForInput.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onChangeFecha = this.onChangeFecha.bind(this);
        this.cargarSucursales = this.cargarSucursales.bind(this);
        this.cargarAuditorias = this.cargarAuditorias.bind(this);
        this.cargarDetalle = this.cargarDetalle.bind(this);
    }

    async componentDidMount() {
        await this.cargarSucursales();
        this.cargarAuditorias();
    }

    formatMomentForInput(d) {
        return d.format('YYYY-MM-DD')
    }

    onChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        })
    }

    onChangeFecha(event) {
        this.setState({
            [event.target.name]: event.target.value
        }, () => {
            this.cargarAuditorias();
        })
    }

    async cargarSucursales() {
        this.setState({ isLoadingSucursales: true })

        try {
            const req = await fetch(`/api/sucursales/SucursalEmpresa`)

            if (!req.ok) {
                throw new Error(req);
            }

            const res = await req.json();

            this.setState({ 
                sucursales: res || [],
                sucursalSeleccionada: res && res.length > 0 ? res[0].IdSucursal : ''
            })
        } catch (e) {
            console.error(e)
            this.setState({ sucursales: [], sucursalSeleccionada: '' })
        } finally {
            this.setState({ isLoadingSucursales: false })
        }
    }

    async cargarAuditorias() {
        if (!this.state.sucursalSeleccionada) {
            return;
        }

        this.setState({ isLoadingAuditorias: true, productos: [] })

        try {
            const req = await fetch(`/api/kardex/auditoria-reinicio-stock/${this.state.sucursalSeleccionada}?fechaInicio=${this.state.fechaInicio}&fechaFin=${this.state.fechaFin}`)

            if (!req.ok) {
                throw new Error(req);
            }

            const res = await req.json();

            this.setState({ 
                auditorias: res || [],
                auditoriaSeleccionada: res && res.length > 0 ? res[0].IdAuditoriaReiniciarStock : ''
            })
        } catch (e) {
            console.error(e)
            this.setState({ auditorias: [], auditoriaSeleccionada: '' })
        } finally {
            this.setState({ isLoadingAuditorias: false })
        }
    }

    async cargarDetalle() {
        if (!this.state.auditoriaSeleccionada) {
            alert('Por favor seleccione una auditoría');
            return;
        }

        this.setState({ isLoading: true })

        try {
            const req = await fetch(`/api/kardex/stock-historico/${this.state.auditoriaSeleccionada}`)

            if (!req.ok) {
                throw new Error(req);
            }

            const res = await req.json();

            this.setState({ 
                productos: res.data || []
            })
        } catch (e) {
            console.error(e)
            this.setState({ productos: [] })
        } finally {
            this.setState({ isLoading: false })
        }
    }

    getDataExportExcel(dataSet) {
        return [
            {
                columns: [
                    {
                        title: `Código`,
                        width: {wpx: 150}
                    },
                    {
                        title: `Cod. de barras`,
                        width: {wpx: 150}
                    },
                    {
                        title: `Nombre `,
                        width: {wpx: 250}
                    },
                    {
                        title: 'Stock',
                        width: {wpx: 100}
                    },
                ],
                data: dataSet.map(row => {
                    return [
                        {
                            value: row.Codigo || row.codigo,
                            style: {
                                fill: { patternType: "solid", fgColor: { rgb: "F6F8FA" } }
                            }
                        },
                        {
                            value: row.CodigoBarra || row.codigoBarra || "",
                            style: {
                                fill: { patternType: "solid", fgColor: { rgb: "F6F8FA" } }
                            }
                        },
                        {
                            value: row.Nombre || row.nombre,
                            style: {
                                fill: { patternType: "solid", fgColor: { rgb: "F6F8FA" } }
                            }
                        },
                        {
                            value: row.Stock || row.stock,
                            style: {
                                fill: { patternType: "solid", fgColor: { rgb: "F6F8FA" } }
                            }
                        }
                    ];
                })
            }
        ];
    }

    render() {
        const dataExport = this.getDataExportExcel(this.state.productos)
        const auditoriaActual = this.state.auditorias.find(a => a.IdAuditoriaReiniciarStock == this.state.auditoriaSeleccionada);

        return (
            <section className="ventas-fpay-section pt-3 pb-5">
                <div className="justify-content-center contenedor-fecha-fpay caja-fondo-blanco-m-2">
                    <span className="align-self-center letra-fecha-fpay">
                        Desde:
                    </span>
                    <input  type="date"
                            className="input__linea mr-1 mt-3 mb-3 linea-fecha-fpay"
                            name="fechaInicio"
                            onChange={this.onChangeFecha}
                            value={this.state.fechaInicio}
                            disabled={!this.state.sucursalSeleccionada}/>

                   <span className="align-self-center letra-fecha-fpay">
                        Hasta:
                    </span>
                    <input  type="date"
                            className="input__linea mr-1 mt-3 mb-3 linea-fecha-fpay"
                            name="fechaFin"
                            onChange={this.onChangeFecha}
                            value={this.state.fechaFin}
                            disabled={!this.state.sucursalSeleccionada}/>
                </div>

                <div className="container">
                    <div className="row caja-fondo-blanco-m-2 p-3 mb-3">
                        <div className="col-md-12 mb-2">
                            <label className="font-weight-bold">Sucursal:</label>
                            <select 
                                className="form-control"
                                name="sucursalSeleccionada"
                                value={this.state.sucursalSeleccionada}
                                onChange={(e) => {
                                    this.setState({ sucursalSeleccionada: e.target.value }, () => {
                                        this.cargarAuditorias();
                                    });
                                }}
                                disabled={this.state.isLoadingSucursales || this.state.sucursales.length === 0}
                            >
                                <option value="">-- Seleccione una sucursal --</option>
                                {this.state.sucursales.map(sucursal => (
                                    <option key={sucursal.IdSucursal} value={sucursal.IdSucursal}>
                                        {sucursal.Nombre}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="row mb-3 caja-fondo-blanco-m-2 p-3">
                        <div className="">
                            <label className="font-weight-bold mr-2">Seleccionar Auditoría:</label>
                            <select 
                                className="form-control"
                                name="auditoriaSeleccionada"
                                value={this.state.auditoriaSeleccionada}
                                onChange={this.onChange}
                                disabled={this.state.isLoadingAuditorias || this.state.auditorias.length === 0}
                            >
                                <option value="">-- Seleccione una auditoría --</option>
                                {this.state.auditorias.map(auditoria => (
                                    <option key={auditoria.IdAuditoriaReiniciarStock} value={auditoria.IdAuditoriaReiniciarStock}>
                                        {auditoria.Usuario} - {auditoria.NombresCompletos} - {moment(auditoria.FechaHora).format('DD/MM/YYYY HH:mm:ss')}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    {auditoriaActual && this.state.productos.length > 0 && (
                        <div className="alert alert-info mb-3">
                            <strong>Stock grabado antes del reinicio de Stock: </strong> {auditoriaActual.Usuario} - {auditoriaActual.NombresCompletos} - {moment(auditoriaActual.FechaHora).format('DD/MM/YYYY HH:mm:ss')} - Sucursal: {auditoriaActual.NombreSucursal}
                        </div>
                    )}

                    <div className="ProcesarBoton mt-1 mb-3">
                        <div className="ProcesarBotones">
                            { this.state.productos.length ? (
                                <ExcelFile
                                    element={
                                        <BotonExcel type="button" title="Guardar Excel"/>
                                    }
                                    filename="StockHistoricoDetalle"
                                >
                                    <ExcelSheet
                                        dataSet={dataExport}
                                        name="Productos"
                                    >
                                    </ExcelSheet>
                                </ExcelFile>
                            ) : null}
                        </div>
                    </div>

                    <div className="d-flex justify-content-end col-sm-auto mb-3 no-pad">
                        <button onClick={this.cargarDetalle} 
                                disabled={this.state.isLoading || !this.state.auditoriaSeleccionada}
                                className="btn btn-outline-primary btn-verde-mfp">
                            {this.state.isLoading ? 'Cargando...' : "Generar"}
                        </button>
                    </div> 

                    <ReactTable
                        id="table-productos-to-xls"
                        data={this.state.productos}
                        loading={this.state.isLoading}
                        filterable={true}
                        sortable={true}
                        columns={[
                            {
                                columns: [
                                    {
                                        Header: "Código",
                                        id: "Codigo",
                                        width: 120,
                                        accessor: d => d.Codigo || d.codigo,
                                        filterMethod: (filter, rows) =>
                                            matchSorter(rows, filter.value, {keys: ["Codigo"]}),
                                        filterAll: true
                                    },
                                    {
                                        Header: "Codigo barra",
                                        id: "CodigoBarra",
                                        width: 110,
                                        accessor: d => d.CodigoBarra || d.codigoBarra,
                                        filterMethod: (filter, rows) =>
                                            matchSorter(rows, filter.value, {keys: ["CodigoBarra"]}),
                                        filterAll: true
                                    },
                                    {
                                        Header: "Nombre",
                                        id: "Nombre",
                                        width: 350,
                                        accessor: d => d.Nombre || d.nombre,
                                        filterMethod: (filter, rows) =>
                                            matchSorter(rows, filter.value, {keys: ["Nombre"]}),
                                        filterAll: true
                                    },
                                    {
                                        id: 'Stock',
                                        Header: 'Stock',
                                        width: 150,
                                        accessor: d => d.Stock || 0,
                                    },
                                    {
                                        id: "TipoStock",
                                        Header: "Tipo de Stock",
                                        width: 400,
                                        accessor: d => d.TipoStock,
                                        filterMethod: (filter, rows) =>
                                            matchSorter(rows, filter.value, {keys: ["TipoStock"]}),
                                        filterAll: true
                                    }
                                ]
                            }
                        ]}
                        defaultPageSize={10}
                        className="-striped -highlight"
                        previousText="Anterior"
                        nextText="Siguiente"
                        noDataText="No se encontraron registros"
                        loadingText="Cargando..."
                        ofText="de"
                        rowsText="filas"
                        pageText="Página"
                        pageSizeOptions={[10, 20, 25, 50, 100]}
                        showPaginationTop={false}
                        showPaginationBottom={true}
                    />
                </div>
            </section>
        );
    }
}


export default StockHistoricoUI;
